  const searchIcon = document.querySelector('.header__actions-action--search');
  const closeIcon = document.querySelector('.header__search-close-btn');
  const closeIcon2 = document.querySelector('.search-close-btn');
  const searchElement = document.querySelector('.header__search');
  const overlay_active = document.querySelector('.backdrop--active');
  const overlay_active_2 = document.querySelector('.backdrop');
  const searchInputUI = document.querySelector('#SearchForm');
  const searchInput = document.querySelector('.header__search .header__search-input');
  
  

  if (window.innerWidth < 769) {
    if (searchElement) {
      searchElement.setAttribute('aria-expanded', 'true');
    }

    let lastScrollTop = 0;
    searchIcon.classList.add('hidden');

    window.addEventListener("scroll", () => {
      // Check if the "backdrop--active" class exists
      const isBackdropActive = document.querySelector('.backdrop--active');

      if (!isBackdropActive) {
        const scrollTop = window.scrollY;

        if (scrollTop > 20 && scrollTop > lastScrollTop) {
          // Hide search bar and show search icon
          searchIcon.classList.remove("hidden");
          searchElement.style.display = 'none'
           // setTimeout(() => {
             closeIcon.style.display = "block";
             closeIcon2.style.display = "none";
           // }, 100); 
          
          if (searchElement) {
            searchElement.setAttribute('aria-expanded', 'false');
          }
        } else if (scrollTop <= 20) {
          // Show search bar and hide search icon
          searchIcon.classList.add("hidden");
          searchElement.style.display = 'block'
          
          closeIcon2.style.display = "block";
          closeIcon.style.display = "none";
          if (searchElement) {
            searchElement.setAttribute('aria-expanded', 'true');
          }
        }

        lastScrollTop = scrollTop;
      }
    });
  } else {
    searchIcon.classList.remove('hidden');
  }

if (window.innerWidth < 769) {
  function handleTopPageState() {
    console.log("window.scrollY", window.scrollY);
   if (searchElement && searchInput) {
    // Check if the element is visible
    const isVisible = !!(searchElement.offsetWidth || 
                       searchElement.offsetHeight || 
                       searchElement.getClientRects().length);

    if (isVisible) {
            searchInput.addEventListener('click', function(event) {
                console.log('Input was clicked');
            });
    
            // iOS-specific focus handling
            setTimeout(() => {
                searchInput.focus();
                
                // Force keyboard to appear on iOS
                if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                    setTimeout(() => {
                      // alert('click')
                        searchInput.click();
                        searchInput.select();
                    }, 200);
                } else {
                    searchInput.click();
                }
            }, 100);
        }
    }
    
    if (window.scrollY === 0) {
      searchIcon.classList.add("hidden");
      closeIcon.style.display = "none";
      closeIcon2.style.display = "block";
      searchElement.style.display = 'block';
      
      if (searchElement) {
        setTimeout(() => {
          searchElement.setAttribute('aria-expanded', 'true');
        }, 100); // 1 second delay
      }
    }
  }

  function onClickChangeColorOfSearch(){
      const closeBtn = document.querySelector('.header__search .header__search-close-btn-icon');
      const searchBtn = document.querySelector('.header__search .header__search-icon');
      const searchInputUi = document.querySelector('#SearchForm');

      if(searchInput){
        searchInput.value = '';
        document.querySelector('.predictive-search__wrap')?.remove();
      }
      
      document.body.style.overflow = '';
      
      if (closeBtn) {
        closeBtn.classList.toggle('red-fill');
      }

      if (searchBtn) {
        searchBtn.classList.toggle('red-stroke');
      }

      if (searchInput) {
        searchInput.classList.toggle('white-placeholder');
        
      }
      
      if(searchInputUi){
        console.log(searchInputUi)
        searchInputUI.classList.remove('search-ui-mobile');
        console.log(searchInputUi)
      }
    }

  // Add event listeners to handle clicks
  if (searchIcon) {
    searchIcon.addEventListener('click', () => {
      searchElement.classList.toggle('open');
      onClickChangeColorOfSearch();
      handleTopPageState();
    });
  }

  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      searchElement.classList.toggle('open');
      
      onClickChangeColorOfSearch();
      handleTopPageState();
    });
  }

  if (overlay_active_2) {
    overlay_active_2.addEventListener('click',  () => {
      searchElement.classList.toggle('open');
      onClickChangeColorOfSearch();
      handleTopPageState();
    });
  }

  document.addEventListener('input', function (event) {
    if (searchInput && event.target === searchInput) {
        if (searchInput.value.length >= 3) {
              console.log("present");

            
            const predictiveSearch = document.querySelector('.header__search');
            const predictiveSearchUI = document.querySelector('.predictive-search');
            if (!predictiveSearch.classList.contains('open')) {
              console.log("contains", predictiveSearch.classList.contains('open'));
              window.innerWidth <= 768 ? predictiveSearchUI.style.margin = '10px -3% 0 -5%' : predictiveSearchUI.style.margin = '0';
            }else{
              console.log("contains", predictiveSearch.classList.contains('open'));
              predictiveSearchUI.style.margin = '0';
            }
        } 
    }
});


const targetNode = document.body; // The node to observe (body in this case)
const config = { childList: true, subtree: true }; // Observe direct children and descendants

const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const predictiveSearchWrap = document.querySelector('.predictive-search__wrap');
            
            if (predictiveSearchWrap) {
                // If .predictive-search__wrap is added, set overflow to hidden
                document.body.style.overflow = 'hidden';
            } else {
                // If .predictive-search__wrap is removed, reset overflow
                document.body.style.overflow = '';
            }
        }
    }
});

// Start observing
observer.observe(targetNode, config);

// To stop observing (optional, you can call this when necessary)
// observer.disconnect();

  
  closeIcon2.addEventListener('click', function() {
    document.body.style.overflow = '';
    searchInput.value = ''
    document.querySelector('.predictive-search__wrap')?.remove();
  });
}

